// Reductor puro del congelado de datos del Avivador v2 (Ajuste #3). Vive
// aparte y SIN imports en tiempo de ejecución porque lo usa
// hooks/use-avivador.ts, que está en el chunk principal (badge del menú,
// invalidarAvivador): si lo importara desde avivador-filtros.ts, todo el
// view-model de la v2 viajaría en el chunk `index` (review de T3a, hallazgo
// H2). avivador-filtros.ts lo re-exporta para los tests y para quien ya lo
// importaba de ahí. El `import type` se borra al compilar.
import type { EntradaCongelado } from './avivador-tipos';

/**
 * ¿Hay que congelar AHORA la foto que tiene la query? Reductor puro que usa
 * `useAvivador` en modo v2 (con `refetchOnMount: 'always'`):
 * - `yaCongelado` → false (lo que llegue después es novedad, T3b);
 * - `!tieneDatos` → false;
 * - `isFetchedAfterMount || !isStale` → true;
 * - si no (hay datos de la caché pero invalidados, p. ej. al volver de la
 *   rede después de registrar algo) → false: la página muestra el skeleton
 *   hasta el fetch fresco.
 * Nota: en TanStack v5 `isFetchedAfterMount` también se pone en true si el
 * fetch después del montaje FALLÓ; entonces se congela la foto vieja (mejor
 * que un skeleton eterno) y `error` queda para el aviso.
 */
export function decidirCongelado(e: EntradaCongelado): boolean {
  if (e.yaCongelado) return false;
  if (!e.tieneDatos) return false;
  return e.isFetchedAfterMount || !e.isStale;
}
